import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(private notificationService: ToastrService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
       // Authorization: `Bearer `
      }
    });
    return next.handle(request).pipe(
        tap(event => {
            if (event instanceof HttpResponse) {
            }
        }, error => {
            if (error instanceof HttpErrorResponse) {
              if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                  let message = 'Your session has expired. Please login once again.'
                  this.notificationService.warning(message, "Session Expired");
                } else if (error.status === 403) {
                  let message = 'You do not have access to that'
                  this.notificationService.warning(message, "Unauthorized");
                } else {
                  if(error.error['message']){
                   if( error.url.includes("ipapi")){
                    return
                   }
                    this.notificationService.error(`${error.error['message']}`, "Error!");
                    console.log(error.message);
                  }
                  else{
                    let message = 'Your session has expired, kindly reload this page.'
                    //this.notificationService.warning(message, "Session Expired");
                  }
                  
                }
              }
            }
        })
    );
  }
}
